import * as React from 'react';
import { Carousel } from '../Carousel';
import { IImageInfo } from '../../types/newbuilding';
import { ISlideProps } from '../Carousel/Carousel';
import { Image } from '../Image';
import { CarouselBlock } from '../CarouselBlock';

interface IPromoSnippetCarouselProps {
  features: React.ReactNode;
  title: string;
  promos: React.ReactNode;
  logo: React.ReactNode;
  images: Pick<IImageInfo, 'thumbnailUrl' | 'fullUrl' | 'isDefault'>[];
}

export function PromoSnippetCarousel({ features, promos, images, title, logo }: IPromoSnippetCarouselProps) {
  return (
    <CarouselBlock isPromo={true} features={features} promos={promos} logo={logo}>
      <Carousel
        isPromo={true}
        slides={images.map(
          (img: IImageInfo, index: number) =>
            // eslint-disable-next-line react/display-name
            ({ visible }: ISlideProps) =>
              visible && (
                <Image
                  alt={`${index + 1}-я Фотография ${title}`}
                  src={img.thumbnailUrl || img.fullUrl}
                  objectFit="cover"
                  lazy
                  loading="lazy"
                />
              ),
        )}
        defaultSlideIndex={images.findIndex((img: IImageInfo) => img.isDefault)}
      />
    </CarouselBlock>
  );
}
